<div [ngClass]="clazz">
  @for (cardCenter of cardsCenter; track cardCenter; let i = $index) {
    <pr-card-center
      [cardCenter]="cardCenter"
      prLoader
      [loading]="loading"
      [ngClass]="{ fill: cardCenter.fill }"
    ></pr-card-center>
  }
</div>
